module.exports = __webpack_public_path__ + "assets/images/b10eaf076dc20f09799ad7959b59266e.png";